import { render, staticRenderFns } from "./uploadData.vue?vue&type=template&id=9dfa2360&scoped=true&"
import script from "./uploadData.vue?vue&type=script&lang=js&"
export * from "./uploadData.vue?vue&type=script&lang=js&"
import style0 from "./uploadData.vue?vue&type=style&index=0&id=9dfa2360&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dfa2360",
  null
  
)

export default component.exports